import { render, staticRenderFns } from "./bookKeeping.vue?vue&type=template&id=31c5006c&scoped=true"
import script from "./bookKeeping.vue?vue&type=script&lang=js"
export * from "./bookKeeping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5006c",
  null
  
)

export default component.exports